export default __webpack_public_path__ + "static/media/intro-box.b98e633a.png";